/* eslint-disable react-refresh/only-export-components */
import React, { createContext, ReactNode, useContext, useMemo, useState } from "react";
import { IUserDocument } from "@/types/type";
import { IAttendanceCodesAndShifts, IAttendanceCodesAndShiftsRequest, IBranch, ICheckpoint, ICompany, ICompletedPatrol, ICreateAttendanceRecordRequest, ICreateDepartmentRequest, ICreateShiftPatternTimeRequest, ICreateShiftPatternTimeResponse, IDepartment, IEditDepartmentRequest, IGetShiftPatternTimesRequest, IGroup, ILoginSelfieResponse, INotification, IPatrol, IPatrolCreateRequest, IPatrolEditRequest, IPatrolReport, IRemoveShiftPatternTimeRequest, IReport, IReportPerson, IRequestModuleById, IRoute, IShift, IShiftRequest, IUpdateAttendanceRecordRequest, IUpdateShiftPatternTimeRequest, IUserPosition, ReportType, IPatrolCopyLastMonthPlanRequest, IExportPatrolsToExcelRequest, IExportPatrolsToPdfRequest, IExportShiftsToPdfRequest, IExportShiftsToExcelRequest, ICreatePositionRequest, ILoginHistory, ISecurityNotificationTemplate, IShiftTemplates, IExportPatrolReportToExcelRequest, IExportPatrolReportToPdfRequest, IForm, ICreateFormRequest, ISubmissionByBranchAndOfficer, IGetSubmissionRequest, IFormDetailBySubmissionId, IFormDetail, IUpdateFormRequest, IExportAttendanceToExcel, IExportAttendanceToPdf, IPayrollSlips, ISendMailPayrollSlipRequest, IUser, IResendPasswordEmailRequest, IExportFormSubmissionToPdfAndExcelRequest, ILeavingCodes, IExportUsersToExcelRequest, IExportSingleUserToExcelRequest, IExportUsersToPdfRequest, IExportSingleUserToPdfRequest, IRequestModule, IAttendaceRecordLog, IAttendanceLockDays, IGetAttendanceRecordsResponse, IUsersByCompanyIdAndRoleIdRequest, IGetShiftReportRequest, IShiftReport } from "@/types/type"; // ICompany tipini kendi projenize göre ayarlayın
import CompaniesService from "@/services/CompaniesService";
import Helpers from "@/utilities/Helpers";
import { toast } from "sonner";
import { CustomAxiosResponse } from "@/configurations/AxiosConfig";
import DepartmentsService from "@/services/DepartmentsService";
import { useAuth } from "./auth/AuthContext";
import { useQuery } from "@tanstack/react-query";
import { useUser } from "./user/UserContext";
import BranchesService from "@/services/BranchesService";
import PatrolsService from "@/services/PatrolsService";
import ShiftsService from "@/services/ShiftsService";
import RoutesService from "@/services/RoutesService";
import CheckpointsService from "@/services/CheckpointsService";
import NotificationsService from "@/services/NotificationsService";
import UploadService from "@/services/UploadService";
import ReportsService from "@/services/ReportsService";
import SecurityNotificationService from "@/services/SecurityNotificationService";
import UserRequestService from "@/services/UserRequestService";
import DocumentsService from "@/services/DocumentsService";
import UsersService from "@/services/UsersService";
import AttendanceRecordsService from "@/services/AttendanceRecordsService";
import FormsService from "@/services/FormsService";
import PayrollSlipsService from "@/services/PayrollSlipsService";
import Constants from "@/constants/Constants";
import { queryKeyFactory } from "@/utilities/queryKeys";
import LocalStorage from "@/utilities/LocalStorage";

interface GlobalContextType {
  companies: ICompany[] | null;
  getCompanyById: (id: string | number) => Promise<ICompany | null>;
  getAllDepartments: () => Promise<IDepartment[]>;
  getDepartmentsByCompanyId: (companyId: string | number) => Promise<IDepartment[]>;
  createCompany: (data: FormData) => Promise<ICompany | null>;
  updateCompany: (id: string | number, data: FormData) => Promise<ICompany | null>;
  departments: IDepartment[];
  deleteBranch: (id: string | number) => Promise<IBranch | null>;
  getPatrolById: (id: string | number) => Promise<IPatrol | null>;
  getPatrolsByUserId: (id: string | number) => Promise<IPatrol[]>;
  getPatrolsReport: (data: any) => Promise<IPatrolReport[]>;
  copyLastMonthPlan: (data: IPatrolCopyLastMonthPlanRequest) => Promise<boolean | null>;
  exportPatrolsToExcel: (data: IExportPatrolsToExcelRequest) => any;
  exportPatrolReportToExcel: (data: IExportPatrolReportToExcelRequest) => any;
  exportPatrolsToPdf: (data: IExportPatrolsToPdfRequest) => any;
  exportPatrolReportToPdf: (data: IExportPatrolReportToPdfRequest) => any;
  exportShiftsToExcel: (data: IExportShiftsToExcelRequest) => any;
  exportShiftsToPdf: (data: IExportShiftsToPdfRequest) => any;
  exportShiftReportToExcel: (data: IGetShiftReportRequest) => Promise<void>;
  exportShiftReportToPdf: (data: IGetShiftReportRequest) => Promise<void>;
  exportFormSubmissionToExcel: (data: IExportFormSubmissionToPdfAndExcelRequest) => any;
  exportFormSubmissionToPdf: (data: IExportFormSubmissionToPdfAndExcelRequest) => any;
  getRequestsByCompanyId: (companyId: string | number) => Promise<IRequestModule[]>;
  updatePatrols: (id: string | number, data: IPatrolEditRequest) => Promise<boolean | null>;
  createPatrol: (data: IPatrolCreateRequest) => Promise<IPatrol | null>;
  deletePatrol: (id: string | number, hiddenMessage?: boolean) => Promise<boolean | null>;
  deletePatternInPatrol: (id: string | number, hiddenMessage?: boolean) => Promise<boolean | null>;
  getShiftsByCompanyId: (companyId: string | number) => Promise<IShift[]>;
  updateShift: (id: string, data: any) => Promise<IShift | null>
  createShift: (data: IShiftRequest) => Promise<IShift | null>
  createShiftPatternTime: (data: ICreateShiftPatternTimeRequest) => Promise<ICreateShiftPatternTimeResponse[] | null>
  updateShiftPatternTime: (data: IUpdateShiftPatternTimeRequest) => Promise<IUpdateShiftPatternTimeRequest[] | null>
  getShiftPatternTimes: (data: IGetShiftPatternTimesRequest) => Promise<ICreateShiftPatternTimeResponse[] | null>
  removeShiftPatternTime: (data: IRemoveShiftPatternTimeRequest) => Promise<ICreateShiftPatternTimeResponse[] | null>
  deleteShift: (id: string | number) => Promise<boolean>;
  getShiftsByShiftId: (shiftId: number | string) => Promise<IShift | null>;
  getShiftsByUserId: (userId: number | string) => Promise<IShift[]>;
  checkIfShiftExistsForMonth: (data: { branch_id: number | null, year: number, month: number }) => Promise<boolean>;
  getShiftTemplates: () => Promise<IShiftTemplates[]>;
  getShiftReport: (data: IGetShiftReportRequest) => Promise<IShiftReport[]>;
  createRoute: (data: any) => Promise<IRoute | null>
  updateRoute: (id: string, data: any) => Promise<IRoute | null>
  getAllCompletedRoutes: () => Promise<ICompletedPatrol[]>;
  getAllCompletedRoutesByCompanyId: (companyId: string | number) => Promise<ICompletedPatrol[]>;
  getCheckpointsByRouteId: (id: string) => Promise<ICheckpoint[]>;
  createCheckpoint: (data: Omit<ICheckpoint, 'id' | 'qr_code'>) => Promise<ICheckpoint | null>
  updateCheckpoint: (data: Omit<ICheckpoint, 'qr_code'>) => Promise<ICheckpoint | null>
  deleteCheckpoint: (id: string | number) => Promise<ICheckpoint | null>;
  deleteCheckListItem: (id: string | number) => Promise<boolean>;
  updateDepartments: (id: string | number, data: IEditDepartmentRequest) => Promise<IDepartment | null>
  getAllNotificationsById: (id: string) => Promise<INotification | null>;
  getAllNotificationsByUserId: (userId: string) => Promise<INotification[]>;
  uploadProfilePhoto: (data: FormData) => Promise<ILoginSelfieResponse | null>;
  createDepartments: (data: ICreateDepartmentRequest) => Promise<IDepartment | null>;
  deleteDepartment: (id: string | number) => Promise<boolean>;
  getCheckpointsPdfByRouteId: (routeId: string | number) => Promise<any>;
  getReportsByCustomerId: (id: string | number) => Promise<IReport | []>;
  getReportTypes: () => Promise<ReportType[] | []>;
  getReportsByReportId: (id: string | number) => Promise<IReport | null>;
  getUsersByReportId: (id: string | number) => Promise<IReportPerson[] | null>;
  createReport: (data: FormData) => Promise<boolean | null>;
  createSecurityNotification: (data: FormData) => Promise<boolean | null>;
  createTemplate: (data: FormData) => Promise<boolean | null>;
  updateTemplate: (id: number, data: FormData) => Promise<boolean | null>;
  removeTemplate: (id: number | string, companyId: number | string) => Promise<boolean>;
  getAllTemplates: (companyId: number | string) => Promise<ISecurityNotificationTemplate[]>;
  getSecurityNotificationsById: (id: number) => Promise<any>;
  markAsReadNotification: (id: string | number) => Promise<boolean>;
  markAllAsReadNotification: (id: string | number) => Promise<boolean>;
  getRequestById: (id: string | number) => Promise<IRequestModuleById | null>;
  sendRequestMessage: (data: FormData) => Promise<boolean>;
  createRequest: (data: FormData) => Promise<boolean>;
  markAsCompleted: (id: string | number) => Promise<boolean>;
  deleteCompany: (id: string | number) => Promise<ICompany | null>;
  deleteDocument: (id: string | number) => Promise<boolean>;
  getUserDocuments: (userId: string | number) => Promise<IUserDocument[]>;
  deleteRoute: (id: string | number) => Promise<boolean | null>;
  getUserGroupsByBranchId: (branchId: string | number) => Promise<IGroup[]>;
  createUserPositions: (data: ICreatePositionRequest) => Promise<IUserPosition | null>;
  deleteUserPosition: (id: string | number) => Promise<boolean>;
  resendPasswordEmail: (data: IResendPasswordEmailRequest) => Promise<boolean | null>;
  createUserGroup: (data: any) => Promise<IGroup | null>;
  deleteUserGroup: (id: number | string) => Promise<boolean>;
  updateUserGroup: (data: any) => Promise<IGroup | null>;
  getAllAttendanceRecords: (data: any) => Promise<IGetAttendanceRecordsResponse | null>;
  getAllAttendanceCodesAndShifts: (data: IAttendanceCodesAndShiftsRequest) => Promise<IAttendanceCodesAndShifts | null>;
  getAttendanceLogs: (data: {company_id: number, date: string}) => Promise<IAttendaceRecordLog[]>;
  getLockedDates: (data: {company_id: number, date: string}) => Promise<IAttendanceLockDays | null>;
  updateAttendanceRecords: (data: IUpdateAttendanceRecordRequest) => Promise<boolean>;
  exportAttendanceRecordToExcel: (data: IExportAttendanceToExcel) => any;
  exportAttendanceToPdf: (data: IExportAttendanceToPdf) => any;
  getLoginHistory: (id: string | number) => Promise<ILoginHistory | null>;
  getUsersByCompanyIdAndRoleId: (data: IUsersByCompanyIdAndRoleIdRequest) => Promise<IUser[] | null>;
  getUserGroupsByCompanyId: (companyId: number | string) => Promise<IGroup[] | null>;
  findByCompanyIdAndPositionId: (data: { company_id: number | string; position_id: number | string }) => Promise<IUser | null>;
  getAllForms: () => Promise<IForm[]>;
  createFormSubmission: (data: ICreateFormRequest) => Promise<boolean | null>;
  getSubmissionByBranchAndOfficer: (data: IGetSubmissionRequest) => Promise<ISubmissionByBranchAndOfficer[] | null>;
  updateFormAnswers: (data: IUpdateFormRequest) => Promise<boolean | null>;
  getSubmissionByFormId: (id: string | number) => Promise<ISubmissionByBranchAndOfficer | null>;
  getSubmissionByFormIdAndCompanyId: (id: string | number, companyId: string | number) => Promise<ISubmissionByBranchAndOfficer | null>;
  getFormDetailBySubmissionId: (submissionId: string | number) => Promise<IFormDetailBySubmissionId | null>;
  getFormDetailById: (id: string | number) => Promise<IFormDetail | null>;
  createPayrollSlip: (data: FormData) => Promise<IPayrollSlips | null>;
  sendMailPayrollSlips: (data: ISendMailPayrollSlipRequest) => Promise<boolean | null>;
  removePayrollSlip: (id: string | number) => Promise<boolean>;
  getLeavingCodes: () => Promise<ILeavingCodes[]>;
  exportUsersToExcel: (data: IExportUsersToExcelRequest) => any;
  exportSingleUserToExcel: (data: IExportSingleUserToExcelRequest) => any;
  exportUsersToPdf: (data: IExportUsersToPdfRequest) => any;
  exportSingleUserToPdf: (data: IExportSingleUserToPdfRequest) => any;
  downloadUserImportTemplate: () => any;
  importUsersFromExcel: (file: FormData) => Promise<boolean | null>;
}

const GlobalContext = createContext<GlobalContextType | undefined>(undefined);

export const GlobalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [companies, setCompanies] = useState<ICompany[]>([]);
  const [departments, setDepartments] = useState<IDepartment[]>([]);
  const { isAuthenticated, user } = useAuth()
  const { getAllRoles, getUsersByCompanyId } = useUser()


  const getAllNotificationsById = async (id: string): Promise<INotification | null> => {
    const response: CustomAxiosResponse<INotification> = await NotificationsService.getAllNotificationsById(id);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const getAllNotificationsByUserId = async (userId: string) => {
    const response: CustomAxiosResponse<INotification[]> = await NotificationsService.getAllNotificationsByUserId(userId);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return [];
    }
  }

  // const getUserGroups = async (): Promise<IGroup[]> => {
  //   const response: CustomAxiosResponse<IGroup[]> = await UsersService.getUserGroups();
  //   if (Helpers.isResponseSuccessful(response)) {
  //     return response.data;
  //   } else {
  //     toast.error(response?.message ?? "Bir hata oluştu!");
  //     return [];
  //   }
  // }

  const getUserGroupsByBranchId = async (branchId: string | number): Promise<IGroup[]> => {
    const response: CustomAxiosResponse<IGroup[]> = await UsersService.getUserGroupsByBranchId(branchId);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return [];
    }
  }

  // const getUserPositions = async (): Promise<IUserPosition[]> => {
  //   const response: CustomAxiosResponse<IUserPosition[]> = await UsersService.getUserPositions();
  //   if (Helpers.isResponseSuccessful(response)) {
  //     return response.data;
  //   } else {
  //     toast.error(response?.message ?? "Bir hata oluştu!");
  //     return [];
  //   }
  // }

  const createUserPositions = async (data: ICreatePositionRequest): Promise<IUserPosition | null> => {
    const response: CustomAxiosResponse<IUserPosition> = await UsersService.createUserPositions(data);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response?.message ?? "Pozisyon başarıyla oluşturuldu!");
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const deleteUserPosition = async (id: string | number): Promise<boolean> => {
    const response: CustomAxiosResponse = await UsersService.deleteUserPosition(id);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response?.message ?? "Pozisyon başarıyla silindi!");
      return true;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return false;
    }
  }

  const resendPasswordEmail = async (data: IResendPasswordEmailRequest): Promise<boolean | null> => {
    const response: CustomAxiosResponse<boolean> = await UsersService.resendPasswordEmail(data);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response?.message ?? "Şifre sıfırlama e-postası başarıyla gönderildi!");
      return true;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const getUserGroupsByCompanyId = async (companyId: number | string): Promise<IGroup[] | null> => {
    const response: CustomAxiosResponse<IGroup[]> = await UsersService.getUserGroupsByCompanyId(companyId);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const companyId = LocalStorage.selectedCompany()?.id

  useQuery({
    queryKey: queryKeyFactory.users.companyId(companyId),
    queryFn: () => getUsersByCompanyId(companyId),
    initialData: [],
    enabled: isAuthenticated && !!user && !!companyId,
  });

  useQuery({
    queryKey: queryKeyFactory.groups.byCompany(companyId),
    queryFn: () => getUserGroupsByCompanyId(companyId),
    initialData: [],
    enabled: isAuthenticated && !!user && !!companyId,
  });

  useQuery({
    queryKey: [Constants.QueryKeys.ROLES],
    queryFn: getAllRoles,
    initialData: [],
    enabled: isAuthenticated && !!user,
    refetchOnWindowFocus: false,
  });

  useQuery({
    queryKey: [Constants.QueryKeys.POSITIONS],
    queryFn: async () => {
      const res = await UsersService.getUserPositions();
      return res.data as IUserPosition[];
    },
    initialData: [],
    enabled: isAuthenticated && !!user,
  });

  // useQuery({ // Hook olarak çağırılmama sebebi GlobalContext içinde çağırıldığında anayapı daha kurulmadığı için hata veriyor.
  //   queryKey: [Constants.QueryKeys.NOTIFICATION],
  //   // queryKey: [Constants.QueryKeys.NOTIFICATION, user?.id],
  //   // queryFn: async ({ queryKey }) => {
  //   //   const [, userId] = queryKey;
  //   //   if (!userId) return [];
  //   //   return await getAllNotificationsByUserId(String(userId));
  //   // },
  //   queryFn: () => user?.id ? getAllNotificationsByUserId(String(user.id)) : Promise.resolve([]),
  //   initialData: [],
  //   // refetchInterval: 10000, // 10 saniyede bir yenile
  //   enabled: isAuthenticated && !!user,
  // });

  // const getAllCompanies = async (): Promise<ICompany[]> => {
  //   const response: CustomAxiosResponse<ICompany[]> = await CompaniesService.getAllCompanies();
  //   if (Helpers.isResponseSuccessful(response)) {
  //     setCompanies(response.data);
  //     return response.data;
  //   } else {
  //     setCompanies([]);
  //     toast.error(response?.message ?? "Bir hata oluştu!");
  //     return [];
  //   }
  // }

  const getCompanyById = async (id: string | number): Promise<ICompany | null> => {
    const response: CustomAxiosResponse<ICompany> = await CompaniesService.getCompanyById(id);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const getLoginHistory = async (id: string | number): Promise<ILoginHistory | null> => {
    const response: CustomAxiosResponse<ILoginHistory> = await UsersService.getLoginHistory(id);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const getUsersByCompanyIdAndRoleId = async (data: IUsersByCompanyIdAndRoleIdRequest): Promise<IUser[] | null> => {
    const response: CustomAxiosResponse<IUser[]> = await UsersService.getUsersByCompanyIdAndRoleId(data);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const findByCompanyIdAndPositionId = async (data: { company_id: number | string; position_id: number | string }): Promise<IUser | null> => {
    const response: CustomAxiosResponse<IUser> = await UsersService.findByCompanyIdAndPositionId(data);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }


  const createCompany = async (data: FormData): Promise<ICompany | null> => {
    const response: CustomAxiosResponse<ICompany> = await CompaniesService.createCompany(data);
    if (Helpers.isResponseSuccessful(response)) {
      setCompanies(prev => [...prev, response.data]);
      toast.success(response?.message ?? "Şirket başarıyla oluşturuldu!");
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const updateCompany = async (id: string | number, data: FormData): Promise<ICompany | null> => {
    const response: CustomAxiosResponse<ICompany> = await CompaniesService.updateCompany(id, data);
    if (Helpers.isResponseSuccessful(response)) {
      setCompanies(prev => [...prev, response.data]);
      toast.success(response?.message ?? "Şirket başarıyla güncellendi!");
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const deleteCompany = async (id: string | number): Promise<ICompany | null> => {
    const response: CustomAxiosResponse<ICompany> = await CompaniesService.deleteCompany(id);
    if (Helpers.isResponseSuccessful(response)) {
      setCompanies(prev => prev.filter(company => company.id !== id));
      toast.success(response?.message ?? "Şirket başarıyla silindi!");
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const createPatrol = async (data: IPatrolCreateRequest): Promise<IPatrol | null> => {
    const response: CustomAxiosResponse<IPatrol> = await PatrolsService.createPatrol(data);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response?.message ?? "Devriye Planı başarıyla oluşturuldu!");
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const updatePatrols = async (id: string | number, data: IPatrolEditRequest): Promise<boolean | null> => {
    const response: CustomAxiosResponse<IPatrol> = await PatrolsService.updatePatrols(id, data);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response?.message ?? "Devriye Planı başarıyla güncellendi!");
      return true;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const deletePatrol = async (id: string | number, hiddenMessage?: boolean): Promise<boolean | null> => {
    const response: CustomAxiosResponse<IPatrol> = await PatrolsService.deletePatrol(id);
    if (Helpers.isResponseSuccessful(response)) {
      !hiddenMessage && toast.success(response?.message ?? "Devriye Planı başarıyla silindi!");
      return true;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const deletePatternInPatrol = async (id: string | number, hiddenMessage?: boolean): Promise<boolean | null> => {
    const response: CustomAxiosResponse<boolean> = await PatrolsService.deletePatternInPatrol(id);
    if (Helpers.isResponseSuccessful(response)) {
      !hiddenMessage && toast.success(response?.message ?? "Başarıyla silindi!");
      return true;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const getAllDepartments = async () => {
    const response: CustomAxiosResponse<IDepartment[]> = await DepartmentsService.getAllDepartments();
    if (Helpers.isResponseSuccessful(response)) {
      setDepartments(response.data);
      return response.data;
    } else {
      setCompanies([]);
      toast.error(response?.message ?? "Bir hata oluştu!");
      return [];
    }
  }

  const getDepartmentsByCompanyId = async (companyId: string | number) => {
    const response: CustomAxiosResponse<IDepartment[]> = await DepartmentsService.getDepartmentsByCompanyId(companyId);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return [];
    }
  }

  const updateDepartments = async (id: string | number, data: IEditDepartmentRequest): Promise<IDepartment | null> => {
    const response: CustomAxiosResponse<IDepartment> = await DepartmentsService.updateDepartments(id, data);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response?.message ?? "Departman başarıyla güncellendi!");
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const createDepartments = async (data: ICreateDepartmentRequest): Promise<IDepartment | null> => {
    const response: CustomAxiosResponse<IDepartment> = await DepartmentsService.createDepartment(data);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response?.message ?? "Birim başarıyla oluşturuldu!");
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const deleteDepartment = async (id: string | number): Promise<boolean> => {
    const response: CustomAxiosResponse = await DepartmentsService.deleteDepartment(id);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response?.message ?? "Departman başarıyla silindi!");
      return true;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return false;
    }
  }


  // const getAllPatrols = async () => {
  //   const response: CustomAxiosResponse<IPatrol[]> = await PatrolsService.getAllPatrols();
  //   if (Helpers.isResponseSuccessful(response)) {
  //     return response.data;
  //   } else {
  //     toast.error(response?.message ?? "Bir hata oluştu!");
  //     return [];
  //   }
  // }

  const getPatrolById = async (id: string | number) => {
    const response: CustomAxiosResponse<IPatrol> = await PatrolsService.getPatrolById(id);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const getPatrolsByUserId = async (id: string | number) => {
    const response: CustomAxiosResponse<IPatrol[]> = await PatrolsService.getPatrolsByUserId(id);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return [];
    }
  }

  const getPatrolsReport = async (data: any) => {
    const response: CustomAxiosResponse<IPatrolReport[]> = await PatrolsService.getPatrolsReport(data);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return [];
    }
  }

  const copyLastMonthPlan = async (data: IPatrolCopyLastMonthPlanRequest) => {
    const response: CustomAxiosResponse<any> = await PatrolsService.copyLastMonthPlanDto(data);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response?.message ?? "Plan başarıyla kopyalandı!");
      return true;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const exportShiftsToExcel = async (data: IExportShiftsToExcelRequest) => {
    await ShiftsService.exportShiftsToExcel(data);
  }

  const exportShiftsToPdf = async (data: IExportShiftsToPdfRequest) => {
    await ShiftsService.exportShiftsToPdf(data);
  }

  const exportShiftReportToExcel = async (data: IGetShiftReportRequest) => {
    await ShiftsService.exportShiftReportToExcel(data);
  }

  const exportShiftReportToPdf = async (data: IGetShiftReportRequest) => {
    await ShiftsService.exportShiftReportToPdf(data);
  }

  const exportPatrolReportToExcel = async (data: IExportPatrolReportToExcelRequest) => {
    await PatrolsService.exportPatrolReportToExcel(data);
  }

  const exportPatrolsToExcel = async (data: IExportPatrolsToExcelRequest) => {
    await PatrolsService.exportPatrolsToExcel(data);
  }

  const exportPatrolReportToPdf = async (data: IExportPatrolReportToPdfRequest) => {
    await PatrolsService.exportPatrolReportToPdf(data);
  }

  const exportPatrolsToPdf = async (data: IExportPatrolsToPdfRequest) => {
    await PatrolsService.exportPatrolsToPdf(data);
  }

  const deleteBranch = async (id: string | number) => {
    const response: CustomAxiosResponse<IBranch> = await BranchesService.deleteBranch(id);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response?.message ?? "Şube başarıyla silindi!");
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  // const getAllShifts = async () => {
  //   const response: CustomAxiosResponse<IShift[]> = await ShiftsService.getAllShifts()
  //   if (Helpers.isResponseSuccessful(response)) {
  //     return response.data
  //   } else {
  //     toast.error(response?.message ?? "Bir hata oluştu!")
  //     return []
  //   }
  // }

  const getShiftsByCompanyId = async (companyId: string | number) => {
    const response: CustomAxiosResponse<IShift[]> = await ShiftsService.getShiftsByCompanyId(companyId)
    if (Helpers.isResponseSuccessful(response)) {
      return response.data
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!")
      return []
    }
  }

  const createShift = async (data: IShiftRequest) => {
    const response: CustomAxiosResponse<IShift> = await ShiftsService.createShift(data)
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response.message ?? "Vardiya eklendi!")
      return response.data
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!")
      return null
    }
  }

  const createShiftPatternTime = async (data: ICreateShiftPatternTimeRequest) => {
    const response: CustomAxiosResponse<ICreateShiftPatternTimeResponse[]> = await ShiftsService.createShiftPatternTime(data)
    if (Helpers.isResponseSuccessful(response)) {
      return response.data
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!")
      return null
    }
  }

  const updateShiftPatternTime = async (data: IUpdateShiftPatternTimeRequest) => {
    const response: CustomAxiosResponse<IUpdateShiftPatternTimeRequest[]> = await ShiftsService.updateShiftPatternTime(data)
    if (Helpers.isResponseSuccessful(response)) {
      return response.data
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!")
      return null
    }
  }

  const getShiftPatternTimes = async (data: IGetShiftPatternTimesRequest) => {
    const response: CustomAxiosResponse<ICreateShiftPatternTimeResponse[]> = await ShiftsService.getShiftPatternTimes(data)
    if (Helpers.isResponseSuccessful(response)) {
      return response.data
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!")
      return null
    }
  }

  const removeShiftPatternTime = async (data: IRemoveShiftPatternTimeRequest) => {
    const response: CustomAxiosResponse<ICreateShiftPatternTimeResponse[]> = await ShiftsService.removeShiftPatternTime(data)
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response.message ?? "Vardiya zaman dilimi başarıyla silindi!")
      return response.data
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!")
      return null
    }
  }

  const updateShift = async (id: string, data: any): Promise<IShift | null> => {
    const response: CustomAxiosResponse<IShift> = await ShiftsService.updateShift(id, data)
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response.message ?? "Vardiya güncellendi!")
      return response.data
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!")
      return null
    }
  }

  const deleteShift = async (id: string | number) => {
    const response: CustomAxiosResponse = await ShiftsService.deleteShift(id)
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response.message ?? "Vardiya silindi!")
      return true
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!")
      return false
    }
  }

  const getShiftsByShiftId = async (shiftId: number | string) => {
    const response: CustomAxiosResponse<IShift> = await ShiftsService.getShiftsByShiftId(shiftId);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const getShiftsByUserId = async (userId: number | string) => {
    const response: CustomAxiosResponse<IShift[]> = await ShiftsService.getShiftsByUserId(userId);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return [];
    }
  }

  const checkIfShiftExistsForMonth = async (data: { branch_id: number | null, year: number, month: number }) => {
    const response: CustomAxiosResponse<{ exists: boolean }> = await ShiftsService.checkIfShiftExistsForMonth(data);
    if (Helpers.isResponseSuccessful(response)) {
      response.data?.exists && toast.warning(response?.message ?? "Seçtiğiniz şubede bu ay için vardiya bulunmaktadır!");
      return response.data?.exists;
    } else {
      return false;
    }
  }

  const getShiftTemplates = async () => {
    const response: CustomAxiosResponse<IShiftTemplates[]> = await ShiftsService.getShiftTemplates()
    if (Helpers.isResponseSuccessful(response)) {
      return response.data
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!")
      return []
    }
  }

  const getShiftReport = async (data: IGetShiftReportRequest) => {
    const response: CustomAxiosResponse<IShiftReport[]> = await ShiftsService.getShiftReport(data)
    if (Helpers.isResponseSuccessful(response)) {
      return response.data
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!")
      return []
    }
  }

  const createRoute = async (data: any) => {
    const response: CustomAxiosResponse<IRoute> = await RoutesService.createRoutes(data)
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response.message ?? "Devriye Rotası eklendi!")
      return response.data
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!")
      return null
    }
  }

  const updateRoute = async (id: string, data: any) => {
    const response: CustomAxiosResponse<IRoute> = await RoutesService.updateRoutes(id, data)
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response.message ?? "Vardiya güncellendi!")
      return response.data
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!")
      return null
    }
  }

  const deleteRoute = async (id: string | number) => {
    const response: CustomAxiosResponse<boolean | null> = await RoutesService.deleteRoute(id)
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response.message ?? "Devriye Rotası silindi!")
      return true
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!")
      return null
    }
  }

  // const getAllRoutes = async () => {
  //   const response: CustomAxiosResponse<IRoute[]> = await RoutesService.getAllRoutes();
  //   if (Helpers.isResponseSuccessful(response)) {
  //     return response.data;
  //   } else {
  //     toast.error(response?.message ?? "Bir hata oluştu!");
  //     return [];
  //   }
  // }
  const getAllCompletedRoutes = async () => {
    const response: CustomAxiosResponse<ICompletedPatrol[]> = await PatrolsService.completedRoutes();
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return [];
    }
  }

  const getAllCompletedRoutesByCompanyId = async (companyId: string | number) => {
    const response: CustomAxiosResponse<ICompletedPatrol[]> = await PatrolsService.getCompletedPatrolsByCompanyId(companyId);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return [];
    }
  }

  const getCheckpointsByRouteId = async (id: string) => {
    const response: CustomAxiosResponse<ICheckpoint[]> = await CheckpointsService.getCheckpointsByRouteId(id);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return [];
    }
  }

  const createCheckpoint = async (data: Omit<ICheckpoint, 'id' | 'qr_code'>) => {
    const response: CustomAxiosResponse<ICheckpoint> = await CheckpointsService.createCheckpoints(data)
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response.message ?? "Kontrol Noktası eklendi!")
      return response.data
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!")
      return null
    }
  }

  const updateCheckpoint = async (data: Omit<ICheckpoint, 'qr_code'>) => {
    const response: CustomAxiosResponse<ICheckpoint> = await CheckpointsService.updateCheckpoints(data)
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response.message ?? "Kontrol Noktası güncellendi!")
      return response.data
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!")
      return null
    }
  }

  const deleteCheckpoint = async (id: string | number) => {
    const response: CustomAxiosResponse<ICheckpoint> = await CheckpointsService.deleteCheckpoint(id);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response.message ?? "Kontrol Noktası silindi!");
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const deleteCheckListItem = async (id: string | number) => {
    const response: CustomAxiosResponse<boolean> = await CheckpointsService.deleteCheckListItem(id);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response.message ?? "Kontrol Listesi Öğesi silindi!");
      return true;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return false;
    }
  }

  const getCheckpointsPdfByRouteId = async (routeId: string | number) => {
    const response: any = await CheckpointsService.getCheckpointsPdfByRouteId(routeId);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response?.message ?? "PDF başarıyla indirildi!");
      return response;
    }
    else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const uploadProfilePhoto = async (data: FormData) => {
    const response: CustomAxiosResponse<ILoginSelfieResponse> = await UploadService.profilePhoto(data);
    if (Helpers.isResponseSuccessful(response)) {
      response.message && toast.success(response.message);
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const createReport = async (data: FormData): Promise<boolean | null> => {
    const response: CustomAxiosResponse<IReport> = await ReportsService.createReport(data);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response?.message ?? "Rapor başarıyla oluşturuldu!");
      return true;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const getReportsByCustomerId = async (id: string | number): Promise<IReport | []> => {
    const response: CustomAxiosResponse<IReport | []> = await ReportsService.getReportsByCustomerId(id);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    }
    else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return [];
    }
  }

  const getReportTypes = async (): Promise<ReportType[] | []> => {
    const response: CustomAxiosResponse<ReportType[] | []> = await ReportsService.getReportTypes();
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    }
    else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return [];
    }
  }

  const getReportsByReportId = async (id: string | number): Promise<IReport | null> => {
    const response: CustomAxiosResponse<IReport | null> = await ReportsService.getReportsByReportId(id);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    }
    else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const getUsersByReportId = async (id: string | number): Promise<IReportPerson[] | null> => {
    const response: CustomAxiosResponse<IReportPerson[] | null> = await ReportsService.getUsersByReportId(id);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    }
    else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const createSecurityNotification = async (data: FormData): Promise<boolean | null> => {
    const response: CustomAxiosResponse<any> = await SecurityNotificationService.createSecurityNotification(data);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response?.message ?? "Bildirim başarıyla oluşturuldu!");
      return true;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const createTemplate = async (data: FormData): Promise<boolean | null> => {
    const response: CustomAxiosResponse<ISecurityNotificationTemplate> = await SecurityNotificationService.createTemplate(data);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response?.message ?? "Şablon başarıyla oluşturuldu!");
      return true;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const updateTemplate = async (id: number, data: FormData): Promise<boolean | null> => {
    const response: CustomAxiosResponse<ISecurityNotificationTemplate> = await SecurityNotificationService.updateTemplate(id, data);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response?.message ?? "Şablon başarıyla güncellendi!");
      return true;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const getAllTemplates = async (companyId: number | string): Promise<ISecurityNotificationTemplate[]> => {
    const response: CustomAxiosResponse<ISecurityNotificationTemplate[]> = await SecurityNotificationService.getAllTemplates(companyId);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return [];
    }
  }

  const removeTemplate = async (id: number | string, companyId: number | string): Promise<boolean> => {
    const response: CustomAxiosResponse<ISecurityNotificationTemplate[]> = await SecurityNotificationService.removeTemplate(id, companyId);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response?.message ?? "Şablon başarıyla silindi!");
      return true;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return false;
    }
  }

  const getSecurityNotificationsById = async (id: number): Promise<any> => {
    const response: CustomAxiosResponse<any> = await SecurityNotificationService.getSecurityNotificationsById(id);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  // const getAllSecurityNotifications = async (): Promise<ISecurityNotification[]> => {
  //   const response: CustomAxiosResponse<ISecurityNotification[]> = await SecurityNotificationService.getAllSecurityNotifications();
  //   if (Helpers.isResponseSuccessful(response)) {
  //     return response.data;
  //   } else {
  //     toast.error(response?.message ?? "Bir hata oluştu!");
  //     return [];
  //   }
  // }

  const markAsReadNotification = async (id: string | number) => {
    const response: CustomAxiosResponse<INotification> = await NotificationsService.markAsReadNotification(id);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response?.message ?? "Bildirim okundu olarak işaretlendi!");
      return true;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return false;
    }
  }

  const markAllAsReadNotification = async (id: string | number) => {
    const response: CustomAxiosResponse<{ count: number }> = await NotificationsService.markAllAsReadNotification(id);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response?.message ?? `${response.data.count} bildirim okundu olarak işaretlendi!`);
      return true;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return false;
    }
  }

  // const getAllRequests = async (): Promise<IRequestModule[]> => {
  //   const response: CustomAxiosResponse<IRequestModule[]> = await UserRequestService.getAllRequests();
  //   if (Helpers.isResponseSuccessful(response)) {
  //     return response.data;
  //   } else {
  //     toast.error(response?.message ?? "Bir hata oluştu!");
  //     return [];
  //   }
  // }

  const getRequestsByCompanyId = async (companyId: string | number): Promise<IRequestModule[]> => {
    const response: CustomAxiosResponse<IRequestModule[]> = await UserRequestService.getRequestsByCompanyId(companyId);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return [];
    }
  }

  const getRequestById = async (id: string | number): Promise<IRequestModuleById | null> => {
    const response: CustomAxiosResponse<IRequestModuleById> = await UserRequestService.getRequestById(id);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const sendRequestMessage = async (data: FormData): Promise<boolean> => {
    const response: CustomAxiosResponse<any> = await UserRequestService.sendRequestMessage(data);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response?.message ?? "Mesaj başarıyla gönderildi!");
      return true;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return false;
    }
  }

  const createRequest = async (data: FormData): Promise<boolean> => {
    const response: CustomAxiosResponse<any> = await UserRequestService.createRequest(data);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response?.message ?? "Talep başarıyla oluşturuldu!");
      return true;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return false;
    }
  }

  const markAsCompleted = async (id: string | number): Promise<boolean> => {
    const response: CustomAxiosResponse<any> = await UserRequestService.markAsCompleted(id);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response?.message ?? "Talep tamamlandı olarak işaretlendi!");
      return true;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return false;
    }
  }

  const deleteDocument = async (id: string | number) => {
    const response: CustomAxiosResponse = await DocumentsService.deleteDocument(id)
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response.message ?? "Doküman silindi!")
      return true
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!")
      return false
    }
  }

  const getUserDocuments = async (userId: string | number): Promise<IUserDocument[]> => {
    const response: CustomAxiosResponse<IUserDocument[]> = await DocumentsService.userDocuments(userId)
    if (Helpers.isResponseSuccessful(response)) {
      return response.data ?? []
    }

    toast.error(response?.message ?? "Bir hata oluştu!")
    return []
  }

  const createUserGroup = async (data: { name: string; user_ids: number[]; company_id: number }) => {
    const response: CustomAxiosResponse<IGroup> = await UsersService.createUserGroup(data);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response.message ?? "Kullanıcı grubu oluşturuldu!");
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const updateUserGroup = async (data: { name: string; user_ids: number[]; group_id: number; status: boolean }) => {
    const response: CustomAxiosResponse<IGroup> = await UsersService.updateUserGroup(data);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response.message ?? "Kullanıcı grubu güncellendi!");
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const deleteUserGroup = async (id: number | string) => {
    const response: CustomAxiosResponse<boolean> = await UsersService.deleteUserGroup(id);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response.message ?? "Kullanıcı grubu silindi!");
      return true;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return false;
    }
  }

  const getAllAttendanceRecords = async (data: ICreateAttendanceRecordRequest): Promise<IGetAttendanceRecordsResponse | null> => {
    const response: CustomAxiosResponse<IGetAttendanceRecordsResponse> = await AttendanceRecordsService.getAllAttendanceRecords(data);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const getAllAttendanceCodesAndShifts = async (data: IAttendanceCodesAndShiftsRequest): Promise<IAttendanceCodesAndShifts | null> => {
    const response: CustomAxiosResponse<IAttendanceCodesAndShifts> = await AttendanceRecordsService.getAllAttendanceCodesAndShifts(data);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const getAttendanceLogs = async (data: {company_id: number, date: string}): Promise<IAttendaceRecordLog[]> => {
    const response: CustomAxiosResponse<IAttendaceRecordLog[]> = await AttendanceRecordsService.getAttendanceLogs(data);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return [];
    }
  }

  const getLockedDates = async (data: {company_id: number, date: string}): Promise<IAttendanceLockDays | null> => {
    const response: CustomAxiosResponse<IAttendanceLockDays> = await AttendanceRecordsService.getLockedDates(data);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const updateAttendanceRecords = async (data: IUpdateAttendanceRecordRequest): Promise<boolean> => {
    const response: CustomAxiosResponse<boolean> = await AttendanceRecordsService.updateAttendanceRecords(data);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response.message ?? "Puantaj başarıyla güncellendi!");
      return true;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return false;
    }
  }

  const exportAttendanceRecordToExcel = async (data: IExportAttendanceToExcel) => {
    await AttendanceRecordsService.exportAttendanceToExcel(data);
  }

  const exportAttendanceToPdf = async (data: IExportAttendanceToPdf) => {
    await AttendanceRecordsService.exportAttendanceToPdf(data);
  }

  const getAllForms = async (): Promise<IForm[]> => {
    const response: CustomAxiosResponse<IForm[]> = await FormsService.getAllForms();
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return [];
    }
  }

  const createFormSubmission = async (data: ICreateFormRequest): Promise<boolean | null> => {
    const response: CustomAxiosResponse<any> = await FormsService.createFormSubmission(data);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response?.message ?? "Form başarıyla gönderildi!");
      return true
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null
    }
  };

  const exportFormSubmissionToExcel = async (data: IExportFormSubmissionToPdfAndExcelRequest) => {
    await FormsService.exportFormSubmissionToExcel(data);
  }

  const exportFormSubmissionToPdf = async (data: IExportFormSubmissionToPdfAndExcelRequest) => {
    await FormsService.exportFormSubmissionToPdf(data);
  }

  const exportUsersToExcel = async (data: IExportUsersToExcelRequest) => {
    await UsersService.exportUsersToExcel(data);
  }

  const exportSingleUserToExcel = async (data: IExportSingleUserToExcelRequest) => {
    await UsersService.exportSingleUserToExcel(data);
  }

  const exportUsersToPdf = async (data: IExportUsersToPdfRequest) => {
    await UsersService.exportUsersToPdf(data);
  }

  const exportSingleUserToPdf = async (data: IExportSingleUserToPdfRequest) => {
    await UsersService.exportSingleUserToPdf(data);
  }

  const downloadUserImportTemplate = async () => {
    await UsersService.downloadUserImportTemplate();
  }

  const getSubmissionByBranchAndOfficer = async (data: IGetSubmissionRequest): Promise<ISubmissionByBranchAndOfficer[] | null> => {
    const response: CustomAxiosResponse<ISubmissionByBranchAndOfficer[] | null> = await FormsService.getSubmissionByBranchAndOfficer(data);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null
    }
  };

  const updateFormAnswers = async (data: IUpdateFormRequest): Promise<boolean | null> => {
    const response: CustomAxiosResponse<any> = await FormsService.updateFormAnswers(data);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response?.message ?? "Form cevapları başarıyla güncellendi!");
      return true
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null
    }
  };

  const getSubmissionByFormId = async (id: string | number): Promise<ISubmissionByBranchAndOfficer | null> => {
    const response: CustomAxiosResponse<ISubmissionByBranchAndOfficer> = await FormsService.getSubmissionByFormId(id);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null
    }
  };

  const getSubmissionByFormIdAndCompanyId = async (id: string | number, companyId: string | number): Promise<ISubmissionByBranchAndOfficer | null> => {
    const response: CustomAxiosResponse<ISubmissionByBranchAndOfficer> = await FormsService.getSubmissionByFormIdAndCompanyId(id, companyId);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null
    }
  };

  const getFormDetailBySubmissionId = async (id: string | number): Promise<IFormDetailBySubmissionId | null> => {
    const response: CustomAxiosResponse<IFormDetailBySubmissionId> = await FormsService.getFormDetailBySubmissionId(id);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null
    }
  };

  const getFormDetailById = async (id: string | number): Promise<IFormDetail | null> => {
    const response: CustomAxiosResponse<IFormDetail> = await FormsService.getFormDetailById(id);
    if (Helpers.isResponseSuccessful(response)) {
      return response.data
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null
    }
  };

  // const getAllPayrollSlips = async (): Promise<IPayrollSlips[] | null> => {
  //   const response: CustomAxiosResponse<IPayrollSlips[]> = await PayrollSlipsService.getAllPayrollSlips();
  //   if (Helpers.isResponseSuccessful(response)) {
  //     return response.data
  //   } else {
  //     toast.error(response?.message ?? "Bir hata oluştu!");
  //     return null
  //   }
  // };

  const createPayrollSlip = async (data: FormData): Promise<IPayrollSlips | null> => {
    const response: CustomAxiosResponse<IPayrollSlips> = await PayrollSlipsService.createPayrollSlip(data);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response?.message ?? "Maaş bordrosu başarıyla oluşturuldu!");
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  };

  const sendMailPayrollSlips = async (data: ISendMailPayrollSlipRequest): Promise<boolean | null> => {
    const response: CustomAxiosResponse<ISendMailPayrollSlipRequest> = await PayrollSlipsService.sendMailPayrollSlips(data);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response?.message ?? "Ücret Pusulası başarıyla gönderildi!");
      return true;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  };

  const removePayrollSlip = async (id: string | number): Promise<boolean> => {
    const response: CustomAxiosResponse<IPayrollSlips> = await PayrollSlipsService.removePayrollSlip(id);
    if (Helpers.isResponseSuccessful(response)) {
      toast.success(response?.message ?? "Ücret pusulası başarıyla silindi!");
      return true;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return false;
    }
  };

  const getLeavingCodes = async (): Promise<ILeavingCodes[]> => {
    const response: CustomAxiosResponse<ILeavingCodes[]> = await UsersService.getLeavingCodes();
    if (Helpers.isResponseSuccessful(response)) {
      return response.data;
    } else {
      toast.error(response?.message ?? "İşten ayrılma kodları getirilirken bir hata oluştu!");
      return [];
    }
  };

  const importUsersFromExcel = async (file: FormData) => {
    const response: CustomAxiosResponse<any> = await UsersService.importUsersFromExcel(file);
    if (Helpers.isResponseSuccessful(response)) {
      response.message && toast.success(response.message);
      return response.data;
    } else {
      toast.error(response?.message ?? "Bir hata oluştu!");
      return null;
    }
  }

  const value = useMemo(
    () => ({
      companies,
      getCompanyById,
      getAllDepartments,
      getDepartmentsByCompanyId,
      createCompany,
      departments,
      deleteBranch,
      updateCompany,
      getPatrolById,
      getPatrolsByUserId,
      getPatrolsReport,
      copyLastMonthPlan,
      exportPatrolsToExcel,
      exportPatrolReportToExcel,
      exportPatrolsToPdf,
      exportPatrolReportToPdf,
      exportShiftsToExcel,
      exportShiftsToPdf,
      exportShiftReportToExcel,
      exportShiftReportToPdf,
      updatePatrols,
      createPatrol,
      deletePatrol,
      getRequestsByCompanyId,
      deletePatternInPatrol,
      getShiftsByCompanyId,
      createShift,
      createShiftPatternTime,
      updateShiftPatternTime,
      getShiftPatternTimes,
      removeShiftPatternTime,
      deleteShift,
      updateShift,
      createRoute,
      updateRoute,
      getAllCompletedRoutes,
      getAllCompletedRoutesByCompanyId,
      getCheckpointsByRouteId,
      createCheckpoint,
      updateCheckpoint,
      deleteCheckpoint,
      deleteCheckListItem,
      getCheckpointsPdfByRouteId,
      updateDepartments,
      getAllNotificationsById,
      getAllNotificationsByUserId,
      uploadProfilePhoto,
      createDepartments,
      deleteDepartment,
      getReportsByCustomerId,
      getReportTypes,
      getReportsByReportId,
      getUsersByReportId,
      createReport,
      createSecurityNotification,
      createTemplate,
      updateTemplate,
      removeTemplate,
      getAllTemplates,
      getSecurityNotificationsById,
      markAsReadNotification,
      markAllAsReadNotification,
      getRequestById,
      sendRequestMessage,
      createRequest,
      markAsCompleted,
      deleteCompany,
      deleteDocument,
      getUserDocuments,
      deleteRoute,
      getUserGroupsByBranchId,
      createUserPositions,
      deleteUserPosition,
      resendPasswordEmail,
      createUserGroup,
      deleteUserGroup,
      updateUserGroup,
      getShiftsByShiftId,
      getShiftsByUserId,
      checkIfShiftExistsForMonth,
      getShiftTemplates,
      getShiftReport,
      getAllAttendanceRecords,
      getAttendanceLogs,
      getLockedDates,
      getAllAttendanceCodesAndShifts,
      updateAttendanceRecords,
      exportAttendanceRecordToExcel,
      exportAttendanceToPdf,
      getLoginHistory,
      getUsersByCompanyIdAndRoleId,
      getUserGroupsByCompanyId,
      findByCompanyIdAndPositionId,
      getAllForms,
      createFormSubmission,
      getSubmissionByBranchAndOfficer,
      updateFormAnswers,
      getSubmissionByFormId,
      getSubmissionByFormIdAndCompanyId,
      getFormDetailBySubmissionId,
      getFormDetailById,
      createPayrollSlip,
      sendMailPayrollSlips,
      removePayrollSlip,
      exportFormSubmissionToExcel,
      exportFormSubmissionToPdf,
      getLeavingCodes,
      exportUsersToExcel,
      exportSingleUserToExcel,
      exportUsersToPdf,
      exportSingleUserToPdf,
      downloadUserImportTemplate,
      importUsersFromExcel,
    }), [companies, departments])

  return (
    <GlobalContext.Provider value={value}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalContext = () => {
  const context = useContext(GlobalContext);
  if (!context) throw new Error("useGlobalContext must be used within a GlobalProvider");
  return context;
};
